import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

const keyMembersAdapter = createEntityAdapter();

const initialState = keyMembersAdapter.getInitialState({
	status: "idle",
	error: null,
});

const keyMembersSlice = createSlice({
	name: "keyMembers",
	initialState,
	reducers: {
		keyMemberUpserted(state, action) {
			keyMembersAdapter.upsertOne(state, action.payload);
		},
		keyMemberRemoved(state, action) {
			keyMembersAdapter.removeOne(state, action.payload);
		},
		keyMembersReceived(state, action) {
			keyMembersAdapter.setAll(state, action.payload);
		},
	},
});

export const { keyMembersReceived, keyMemberUpserted, keyMemberRemoved } =
	keyMembersSlice.actions;

export const {
	selectAll: selectAllKeyMembers,
	selectById: selectKeyMemberById,
} = keyMembersAdapter.getSelectors((state) => state.capex.keyMembers);

export default keyMembersSlice.reducer;
